import axios from 'axios'
import { EXCLUIR_USUARIO_EMPRESA_AGENCIA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirUsuariosEmpresaAgencia (idEmpresa, idUsuarioEmpresaAgencia) {

  const url = `${URL}/usuarios-empresa-agencia/${idUsuarioEmpresaAgencia}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_USUARIO_EMPRESA_AGENCIA,
        payload: response
      })
  );
}
